// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
    breakpointMobile: '1023',
    suggestionMobileStyle: 'style2', // style1, style2,
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	},
  general: {
    breakpointMobile: '1023'
  }
}; 

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function() {
    bindEventsMobile.call(this);

    var self = this;
    var searchButtonMobile = '.site-nav--mobile .search-button, .js-search-destop';
    var searchInputMobile = '.search-input-group input[type="search"], .wg-search-form .search-input';
    var searchCloseButtonMobile = '.drawer__close > button, .drawer_back a';

    // var searchButtonMobile = '.header-search-form-toggle .icon-search';
    // var searchInputMobile = '.header-search-form .search-input';
    // var searchCloseButtonMobile = '.header-search-form .icon-close';
    jQ(searchButtonMobile).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputMobile).focus();
      self.openSuggestionMobile();
      jQ(searchCloseButtonMobile).trigger('click');

    });
  }
  
  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function() {
    bindEvents.call(this);

    var self = this;
    var searchButtonDesktop = '.site-header__links .search-button';
    var searchInputDesktop = '#SearchContainer #search-input';
    var searchCloseButtonDesktop = '.drawer__close > button';
    jQ(searchButtonDesktop).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputDesktop).focus();
      self.openSuggestionStyle3();
      jQ(searchCloseButtonDesktop).trigger('click');

    });
  }

  // Fix search for the Flow theme
  jQ('.site-header__links .search-button').on('click', function() {
    setTimeout(function() {
      boostPFS.initSearchBox();
      if(Utils.isCollectionPage()) jQ('.search-input-group > .boost-pfs-search-box').val('');
    }, 500);
  });

  // Only send Weglot request if the current language is different from English
  function isWeglotActive() {
    if (!window.Weglot || !window.Weglot.initialized) {
        return false;
    } else {
      var currentLang = Weglot.getCurrentLang();
  // Change 'en' to suitable with original language of the store
      return currentLang !== 'en';
    }
  }

  SearchAutoComplete.prototype._onKeyboardNavigation = function(e) {
		if (this._isXSSSearchTerm(e)) return;

		if (!this.isOpen || !this.$element || !e || !e.key) return;
		var $suggestionItems = this.$element.find('.' + Class.searchSuggestionItem);
		if ($suggestionItems.length <= 0) return;
		var $viewAll = this.$element.find('[data-group=view-all]');
		var numberOfItems = $suggestionItems.length + $viewAll.length;

		var isStopPropagation = false;

		if (e.key.includes('Down') || e.key.includes('Up')) {
			isStopPropagation = true;
			if (e.key.includes('Up')) {
				this.keyboardNavIndex--;
				if (this.keyboardNavIndex < -1) {
					this.keyboardNavIndex = numberOfItems - 1;
				}
			} else if (e.key.includes('Down')) {
				this.keyboardNavIndex++;
				if (this.keyboardNavIndex > numberOfItems - 1) {
					this.keyboardNavIndex = -1;
				}
			}
			this.$inputElement.focus();
			// Select input
			if (this.keyboardNavIndex == -1) {
				this.$keyboardSelectedItem = null;
				var textValue = Utils.stripHtml(Globals.currentTerm);
				this.$inputElement.val(textValue);
				$suggestionItems.removeClass('selected');
			// Select view all
			} else if (this.keyboardNavIndex > $suggestionItems.length - 1) {
				this.$keyboardSelectedItem = null;
				var textValue = Utils.stripHtml(Globals.currentTerm);
				this.$inputElement.val(textValue);
				$suggestionItems.removeClass('selected');
				$viewAll.addClass('selected');
			// Select suggestion items
			} else {
				$suggestionItems.each((index, item) => {
					var $item = jQ(item);
					console.log(item)
					if (index == this.keyboardNavIndex) {
						var textValue = Utils.stripHtml($item.attr('data-title'));
						this.$inputElement.val(textValue);
						$item.addClass('selected');
						$viewAll.removeClass('selected');
						this.$keyboardSelectedItem = $item;
					} else {
						$item.removeClass('selected');
					}
				})
			}
		} else if (e.key.includes('Left') || e.key.includes('Right')) {
			if (this.keyboardNavIndex != -1) {
				isStopPropagation = true;
			}
		}
		if (isStopPropagation) {
			e.stopImmediatePropagation();
			e.stopPropagation();
			e.preventDefault();
		}
	}

  InstantSearchApi.beforeCallAsync = function(searchTerm, callInstantSearchApi) {
    // Then use it in our API
    if (window.Weglot && window.Weglot.initialized && isWeglotActive()) {
    
        console.log(Globals.currentTerm);
        var a = Weglot.search(Globals.currentTerm, function(englishTerm) {
          console.log('englishTerm:', englishTerm);
          Globals.instantSearchQueryParams['q'] = englishTerm;
          callInstantSearchApi();
          // Weglot's code to hide the searched query after the form submission to prevent the user to notice the untranslated query
          const target = document.querySelector('input#boost-pfs-search-box-0');
          const searchForm = document.querySelector('form.header-search-form');
          var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
            target.addEventListener("keypress", function(event) {
              if(event.key === "Enter") {
                target.style.opacity = 0;
              }
            });
          });
        });
          var config = { attributes: true }
          observer.observe(target, config);
        // End of Weglot code

        console.log(`callInstantSearchApi`);
        });
    } else {
        callInstantSearchApi();
    }
  }
})();